var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ui-checkbox",class:[
    _vm.checkboxChecked ? 'ui-checkbox--checked' : null,
    _vm.isDisabled ? 'ui-checkbox--disabled' : null,
  ]},[_c('span',{staticClass:"ui-checkbox__checkbox"},[(_vm.checkboxChecked)?_c('CheckIcon'):_vm._e()],1),_c('span',{staticClass:"ui-checkbox__text"},[_vm._v(_vm._s(_vm.checkboxText))])])
}
var staticRenderFns = []

export { render, staticRenderFns }